import { stripInline } from '@wds/astro-bot-shared/course/inline';
import { InlineText } from './InlineText';
import styles from './Course.module.css';

/** A row of lesson pictures (exercise image + extra images, quiz images). Alt text = caption or ''. */
export function CoursePictures({ images, alt = '' }: { images: (string | null | undefined)[]; alt?: string }): JSX.Element | null {
  const list = images.filter((x): x is string => !!x);
  if (list.length === 0) return null;
  return (
    <div className={styles.pictures}>
      {list.map((src, i) => (
        <img key={`${src}-${i}`} className={styles.picture} src={src} alt={alt} loading="lazy" />
      ))}
    </div>
  );
}

export function Figure({ image, caption }: { image: string; caption: string }): JSX.Element {
  return (
    <figure className={styles.figure}>
      <img className={styles.picture} src={image} alt={stripInline(caption)} loading="lazy" />
      {caption && <figcaption className={styles.caption}><InlineText text={caption} /></figcaption>}
    </figure>
  );
}
